<template>
  <article v-scroll:reveal class="layout-cta -bottom">
    <RouterLink :to="{ name: 'about-members-register' }" class="layout-cta__box -accent">
      <BranchShape v-scroll:reveal="{ delay: 125 }" class="layout-cta__branch" color="white" opacity="0.1" />

      <div v-scroll:reveal="{ delay: 75 }" class="layout-cta__content">
        <h4 class="layout-section__heading">{{ wp.cta.title }}</h4>
        <p>
          {{ wp.cta.text }}
        </p>
      </div>

      <button v-scroll:reveal="{ delay: 175 }" class="layout-cta__button">
        <SvgIcon id="action-arrow" />
      </button>
    </RouterLink>
  </article>
</template>

<script>
export default {
  name: 'AboutMemberssCta',
  inject: ['wp']
}
</script>
